import axios from "axios";

const http = axios.create({
     baseURL: global.API_URI || "https://esp.demo2.mixmedia.com/api",

})

http.interceptors.response.use(function (resp) {
    return Promise.resolve(resp.data);
});

export default {
    getList() {
        return http.get("activities",{});

    }
}